import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router";
import { PageHelmet } from "@/src/common/components/page-helmet";
import { Button } from "@/src/common/components/ui";

export default function NotFoundPage() {
	const { t } = useTranslation("common");
	const navigate = useNavigate();

	return (
		<>
			<PageHelmet title={t("not_found_title")} />
			<div className="flex min-h-screen items-center justify-center bg-background px-6">
				<div className="flex flex-col items-center text-center max-w-md">
					<p className="text-9xl font-extrabold bg-linear-to-br from-primary to-secondary bg-clip-text text-transparent select-none">404</p>
					<h1 className="mt-4 text-2xl font-semibold text-foreground">{t("not_found_title")}</h1>
					<p className="mt-2 text-foreground/50 text-balance">{t("not_found_description")}</p>
					<div className="mt-8 flex gap-3">
						<Button variant="outline" onPress={() => navigate(-1)}>
							{t("go_back")}
						</Button>
						<Link to="/">
							<Button variant="primary">{t("go_home")}</Button>
						</Link>
					</div>
				</div>
			</div>
		</>
	);
}
